<template>
	<div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row style="width: 100%" align="center" justify="start" class="ma-0">
				<v-col cols="auto" sm="6" xs="6" md="12" lg="auto">
					<slot name="breadcrumbs"></slot>
				</v-col>
				<v-spacer/>
				<v-col cols="auto" v-if="showExportBtns">
					<!-- export -->
					<v-menu offset-y>
						<template v-slot:activator="{ on }">
							<v-btn dark color="printingColor" class="px-2" v-on="on">
								<span class="d-flex align-center">
									<v-icon color="white">mdi-export-variant</v-icon>
									<span style="font-size: 14px">
										{{$t('WarehouseInventoryPage.export')}}
									</span>
								</span>
							</v-btn>
						</template>

						<bee-list>
							<!-- excel -->
							<bee-list-item
								context="inventory"
								:item="exportItems[0]"
								dense
								@click="exportAs('excel')"
							></bee-list-item>

							<!-- pdf -->
							<bee-list-item
								context="inventory"
								:item="exportItems[1]"
								dense
								@click="exportAs('pdf')"
							></bee-list-item>
						</bee-list>
					</v-menu>
				</v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="pe-lg-0">
					<bee-autocomplete
						v-model="warehouse_id"
						:label="$t('WarehouseInventoryPage.warehouse')"
						:items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
						item-text="name"
						item-value="id"
						@keydown-enter-prevent="search()"
						:hide-details="true"
						context="inventory"
						:action-name="actions.GET"
					></bee-autocomplete>
				</v-col>

				<v-col cols="auto" lg="3" md="auto" class="pe-lg-0">
					<!-- fixed for multiple warehouses -->
					<bee-material-autocomplete
						:label="$t('WarehouseInventoryPage.search-by-material-name-or-num')"
						:items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? materials.filter(c => c.warehouse_id === tableInputs.warehouse_id && c.type === 2) : warehouse_id ? materials.filter(c => c.warehouse_id === warehouse_id) : materials"
						v-model="material_id"
						ref="BeeAutocomplete"
						@keydown-enter-prevent="search()"
						:with-balance="true"
						:hide-details="true"
						clearable
						context="inventory"
						:action-name="actions.GET"
					></bee-material-autocomplete>
				</v-col>

				<!-- <v-col cols="auto">
					<v-autocomplete 
						v-model="deliveryStatus"
						:items="materialDeliveryStatus"
						item-text="name"
						item-value="id"
						outlined
						hide-details
						dense
						:label="$t('WarehouseInventoryPage.material-delivery-status')"
					/>
				</v-col> -->
			
				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex align-center pe-lg-0">
					<bee-checkbox
						v-model="with_primary_materials"
						:label="$t('WarehouseInventoryPage.show-main-materials')"
						class="small-font-size mt-0"
					></bee-checkbox>
				</v-col>
				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex align-center pe-lg-0">
					<bee-checkbox
						v-model="where_materials_have_balances"
						:label="$t('WarehouseInventoryPage.only-materials-which-have-balances')"
						class="small-font-size mt-0"
					></bee-checkbox>
				</v-col>
				<v-spacer></v-spacer>
				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex align-center justify-end">
					<bee-btn
						@click="search()"
						:content="$t('WarehouseInventoryPage.refresh')"
						color="blueGray"
						outer-class="me-3"
						:loading="loading"
						context="inventory"
						:action-name="actions.GET"
					></bee-btn>
					<bee-btn
						@click="reset()"
						:content="$t('WarehouseInventoryPage.cancel')"
						color="deletingColor"
						:loading="loading"
						context="inventory"
						:action-name="actions.GET"
					></bee-btn>
				</v-col>
			</v-layout>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
			<v-card flat>
				<v-card-text class="pt-0 px-3 mb-6">
					<bee-simple-table
						:with-color="false"
						:zebra="zebra"
						:hide-footer="true"
						empty-state="dashes"
						context="inventory"
						:fixed-header="true"
						:action-name="actions.GET"
						:headers="headers"
						:items="inventory_rows"
						:right-click-menu-items="menu_items"
						:configs="configs"
						:highlighted-expression="(item)=>{return item.is_parent ? 'orangeLighten5' : ''}"
						:show-menu-actions="true"
						@edit="editInventoryPrice($event)"
						@statement="statement($event)"
					>
						<template v-slot:[`item.count`]="{ item }">
							<bee-label :bold="true" :content="item.count" :color="item.count < 0 ? 'red' : ''" empty-state="_"></bee-label>
						</template>
						<template v-slot:[`item.calculated_total_amount`]="{ item }">
							<bee-money-label
                                :readonly="true" :type="item.calculated_total_amount.amount < 0 ? 'debit' : undefined"
                                class="input-text-center" :inside-table="true" :with-color="true"
                                :number="item.calculated_total_amount.amount" empty-state="_"
                            ></bee-money-label>
						</template>
					</bee-simple-table>
				</v-card-text>
			</v-card>
			<v-bottom-navigation app id="footer" class="px-3" horizontal background-color="greyLighten3">
				<v-row align="center" justify="center">

					<v-spacer></v-spacer>
					<!-- العدد الكلي -->
					<v-col cols="auto">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.total-count')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="total_count"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>

					<!-- الكمية الكلية -->
					<v-col cols="auto">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.total-quantity')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="sum_quantity"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>

					<!-- جرد المستودع -->
					<v-col cols="auto" class="mb-2">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.warehouse-inventory')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-money-label :number="sum_total_amount.amount" :type="sum_total_amount.type" :withColor="true" empty-state="_"></bee-money-label>
							</template>
						</bee-outlined-header-info>
					</v-col>
				</v-row>
			</v-bottom-navigation>
			<v-form v-model="valid">
				<v-dialog
					persistent
					v-model="dialogEditInventoryPrice"
					max-width="400px"
					transition="dialog-top-transition"
				>
					<v-card>
						<v-card-title>{{ formTitle }}</v-card-title>

						<v-card-text class="pb-0">
							<v-row justify="center">
								<v-col cols="12" class="mx-5">
									<bee-numeric-field
										context="material"
										:action-name="actions.EDIT"
										v-model="inventoryPrice"
										:label="$t('WarehouseInventoryPage.inventory-price')"
										:rules="[rules.money]"
									></bee-numeric-field>
								</v-col>
							</v-row>
						</v-card-text>

						<v-card-actions class="px-5">
							<v-btn color="greenDarken1" text @click="confirmEditInventoryPrice()" :disabled="!valid">
								{{$t('WarehouseInventoryPage.save')}}
							</v-btn>
							<v-btn color="redDarken1" text @click="close()">
								{{$t('WarehouseInventoryPage.cancel')}}
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-form>
			<bee-confirm-dialog
				@close="alertEditingPrimaryMaterial = false"
				confirm-button-color="red"
				v-model="alertEditingPrimaryMaterial"
				:title="$t('WarehouseInventoryPage.warning')"
				:message="$t('WarehouseInventoryPage.it-is-not-possible-to-set-main-material-inventory-price')"
			></bee-confirm-dialog>
		</div>
	</div>
</template>
<script>
import store from "../../../store/index.js";
import { mapState } from "vuex";
import actions from "../../../permissions/actions-names.js";
import ls from "../../../settings/localStorageExtension";
import rules from "../../../validation";
import { userType } from '@/helpers/enums';
import { multipleWarehouses } from '@/configs/global'

export default {
	data: () => ({
		alertEditingPrimaryMaterial: false,
		inventoryPrice: null,
		...rules,
		valid: false,
		dialogEditInventoryPrice: false,
		actions,
		where_materials_have_balances: true,
		zebra: true,
		loading: false,
		with_primary_materials: null,
		material_id: null,
		warehouse_id: null,
		selectedRow: {
			material_id: null,
			price: { amount: null, currency_id: null }
		},
		default_summary: {
			inventory_is_not_complete: null,
			sum_quantity: null,
			sum_total_amount: { amount: null, currency_id: null },
			total_count: null
		},
		showExportBtns: false,
		userType,
		multipleWarehouses,
		// materialDeliveryStatus,
		DeliveryStatus: null
	}),

	computed: {
		...mapState({
			warehouses: state => state.warehouses.warehouses,
			materials: state => state.materials.materials,
			inventory: state => state.statements.inventory,
			configs: state => state.configs.configs,
			unit_sizes: state => state.unitSizes.unit_sizes,
			warehousesForKeeper: state => state.warehouses.warehousesForKeeper,
			userTypePermission: state => state.permissions.user_type,
		}),

		exportItems() {
			return [
				{
					text: this.$t('WarehouseInventoryPage.export-as-excel'),
					icon: 'mdi-microsoft-excel',
					context: 'inventory',
					action_name: actions.EXPORT_AS_PDF
				},
				{
					text: this.$t('WarehouseInventoryPage.print-warehouse-inventory'),
					icon: 'mdi-printer',
					context: 'inventory',
					action_name: actions.EXPORT_AS_PDF
				},
			]
		},

		headers() {
			return [
				// cannot use dublicate same value for configs  ... fast fix spacae and trim other side clean
				{
					text: this.$t('WarehouseInventoryPage.headers.material-no'),
					value: " material_id",
					type: "autocomplete",
					width: "10%",
					settings: { itemText: "no", itemValue: "id", items: this.materials }
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.material-name'),
					value: "material_id",
					type: "autocomplete",
					width: "15%",
					settings: { itemText: "name", itemValue: "id", items: this.materials }
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.count'),
					value: "count",
					type: "",
					width: "15%"
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.unit-size'),
					value: "unit_size_id",
					type: "autocomplete",
					width: "10%",
					settings: {
						itemText: "name",
						itemValue: "id",
						items: this.unit_sizes
					}
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.quantity'),
					value: "quantity",
					type: "quantity",
					width: "15%"
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.price'),
					value: "price",
					type: "money",
					width: "15%"
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.total-amount'),
					value: "calculated_total_amount",
					type: "",
					width: "20%"
				}
			];
		},

		menu_items() {
			return [
				{
					name: 'edit',
					disabled: this.file_is_locked,
					text: this.$t('WarehouseInventoryPage.context-menu.edit-inventory-price'),
					action_name: actions.EDIT
				},
				{
					name: 'statement',
					disabled: false,
					text: this.$t('WarehouseInventoryPage.context-menu.material-statement'),
					action_name: actions.GET
				}
			]
		},

		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},
		inventory_rows() {
			return this.inventory?.inventory_rows || [];
		},	
		summary(){
			return this.inventory?.inventory_report_summary || this.default_summary
		},
		formTitle() {
			return this.$t('WarehouseInventoryPage.edit-inventory-price') + this.materials?.find(c => c.id == this.selectedRow.material_id)?.name;
		},
		sum_total_amount() {
			let amount = this.summary.sum_total_amount.amount
			let type = amount ? (amount >= 0 ? 'credit' : 'debit') : 'debit'
			return { amount, type }
		},
		total_count() {
			return { quantity: this.summary.total_count }
		},
		sum_quantity() {
			return { quantity: this.summary.sum_quantity }
		},
	},

	methods: {
		search() {
			this.loading = true;
			store.dispatch("statements/createInventoryReport", {
				warehouse_id: this.material_id ? null :this.warehouse_id,
				material_id: this.material_id,
				with_primary_materials: this.with_primary_materials,
				where_materials_have_balances: this.where_materials_have_balances,
				// materialDeliveryStatus: this.deliveryStatus
			})
			.finally(() => {
				this.showExportBtns = true;
				this.loading = false;
				this.zebra = !this.with_primary_materials;
			});
		},
		reset() {
			this.showExportBtns = false;
			this.warehouse_id = null;
			this.material_id = null;
			this.with_primary_materials = false;
			this.where_materials_have_balances = true;
			this.zebra = true;
			this.deliveryStatus = null
			this.close();
			this.$store.dispatch("statements/clear");
			this.$refs["BeeAutocomplete"].$refs.BeeMaterialAutocomplete.$refs.BeeAutocomplete.focus();
		},
		// onChange(string) {
		// 	if (string == "material_id") {
		// 		this.warehouse_id = null;
		// 	} else {
		// 		this.material_id = null;
		// 	}
		// },
		editInventoryPrice(row) {
			if (row.is_parent) {
				this.alertEditingPrimaryMaterial = true;
				return;
			}
			this.selectedRow = { ...row };
			this.inventoryPrice =
				this.selectedRow.price && this.selectedRow.price.amount > 0
					? this.selectedRow.price.amount
					: null;
			this.dialogEditInventoryPrice = true;
		},
		confirmEditInventoryPrice() {
			store.dispatch("materials/updateinventoryPrice", {
				warehouse_id: this.materials.find(
					c => c.id == this.selectedRow.material_id
				).warehouse_id,
				material_id: this.selectedRow.material_id,
				invevtory_price: this.inventoryPrice
			})
			.then(() => this.search())
			.finally(() => this.close());
		},
		close() {
			this.selectedRow = {
				material_id: null,
				price: { amount: null, currency_id: null }
			};
			this.inventoryPrice = null;
			this.dialogEditInventoryPrice = false;
		},
		statement(row){
			let routeData = this.$router.resolve({name: 'material-statment', params: {id: row.material_id}});
			window.open(routeData.href, '_blank');
		},

		exportAs(type) {
			if (this.showExportBtns){
				this.$store.dispatch('reports/InventoryReport', {
					type,
					financialFileId: this.configs.financial_file.id,
					userId: ls.getLocalUser().id,
					warehouseId: this.warehouse_id,
					materialId: this.material_id ? this.material_id : null,
					withPrimaryMaterials: this.with_primary_materials,
					whereMaterialsHaveBalances: this.where_materials_have_balances
				})
			}
		}
	},

	mounted() {
		window.observer.observe(document.querySelector("#tool-bar"))
		window.observer.observe(document.querySelector("#footer"))
		this.reset();
		if (this.$route.query.warehouseId) {
			this.warehouse_id = this.$route.query.warehouseId;
			this.search();
		}
	},

	beforeDestroy() {
		this.$store.dispatch("statements/clear");
	},

	async beforeRouteEnter(to, from, next) {
		let promises = [
			store.dispatch("warehouses/fetchAll"),
			store.dispatch("materials/fetchAll"),
			store.dispatch("unitSizes/fetchAll")
		];

		await Promise.all(promises);
		next();
	}
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin: 150px auto;
}
.small-font-size .v-label {
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>